import React from 'react';
import { useHistory } from 'react-router-dom';
import { version } from '../../../package.json';
import {
	AppBar, ExtendedTheme, IconButton,
	UserInterfaceSearch,
	UserInterfacePreferences,
	UserInterfaceUserCircle, UserInterfaceMail, UserDetails} from 'neon-design-system';
import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { config } from '../../config';
import { AccountMenuItem } from 'neon-design-system/build/src/component-library/Navigation/AppBar/Buttons/IconButtons/Account/Account';
import { baseUrls } from '../../utils/baseUrls.utils';

export interface ResearchAppBarProps {
	userDetails?: UserDetails;
	menuItems?: {
		name: string;
		link: string;
		isActive?: boolean;
	}[];
	onSignOut: () => void;
}

const useUtilityLinkStyles = makeStyles((theme: ExtendedTheme) => createStyles({
	menuButton: {
		color: `${theme.palette.grey[200]} !important`,
		'&:hover': {
			color: `${theme.palette.grey[100]} !important`
		}
	},
	buttonWrapper: {
		'& > button': {
			minWidth: 40,
			padding: `${theme.spacing(2)}px 0`
		}
	}
}));

const UtilityLink = (props: { id: string; path: string; Icon: React.FC<any> }) => {
	const classes = useUtilityLinkStyles();
	const history = useHistory();

	return (
		<div className={classes.buttonWrapper} id={props.id}>
			<IconButton
				className={classes.menuButton}
				onClick={() => history.push(props.path)}
			>
				<props.Icon />
			</IconButton>
		</div>
	);
}

const useResearchAppBarStyles = makeStyles((theme: ExtendedTheme) => createStyles({
	root: {
		'@media print': {
			display: 'none'
		}
	}
}));


const ResearchAppBar = (props: ResearchAppBarProps) => {
	const history = useHistory();
	const classes = useResearchAppBarStyles();

	const optionalUtilityItems = [
		<UtilityLink id="app-header-search-button" path={baseUrls.search} Icon={UserInterfaceSearch} />
	];

	const optionalUtilitiesMobileContent = <UtilityLink id="app-header-search-button" path={baseUrls.search}
		Icon={UserInterfaceSearch} />;

	const accountMenuItems = [
		{
			name: 'Manage account',
			icon: <UserInterfaceUserCircle />,
			onClick: () => {
				window.location.href = manageProfileLink
			}
		},
		{
			name: 'Manage email notifications',
			icon: <UserInterfacePreferences />,
			onClick: () => {
				history.push(baseUrls.emailNotifications)
			}
		},
		{
			name: 'Contact support',
			icon: <UserInterfaceMail />,
			onClick: () => {
				window.location.href = supportEmail
			}
		}
	].filter(t => !!t) as AccountMenuItem[];

	const mobileFooterMenuItems = [
		{
			name: 'Manage email notifications',
			icon: <UserInterfacePreferences />,
			onClick: () => {
				history.push(baseUrls.emailNotifications)
			}
		},
		{
			name: 'Search',
			icon: <UserInterfaceSearch />,
			onClick: () => history.push(baseUrls.search)
		}
	].filter(t => !!t) as AccountMenuItem[];

	const manageProfileLink = config.landingPageUrl + '/manage-account/profile';

	const supportEmail = 'mailto:neonsupport@marex.com?subject=Neon%20Insights';

	const versionText = ' ' + version.replace('-', '.');

	return (
		<div className={classes.root}>
			<AppBar
				id="app-header"
				app="Insights"
				userDetails={props.userDetails}
				menuItems={props.menuItems}
				onSignOut={props.onSignOut}
				optionalUtilitiesContent={optionalUtilityItems}
				optionalUtilitiesMobileContent={optionalUtilitiesMobileContent}
				appVersion={versionText}
				homePageLink="/insights"
				homePageRoute={baseUrls.forYou}
				showAppSwitcher
				accountMenuItems={accountMenuItems}
				mobileFooterMenuItems={mobileFooterMenuItems} />
		</div>
	)
};

export default ResearchAppBar;
